export default __webpack_public_path__ + "static/media/camb_logo_monochromatic.0da186b0.svg";